<template>
  <div class="thailand-map-container">
    <svg viewBox="0 0 1000 1000" class="thailand-map">
      <!-- Northern Region -->
      <g 
        @mouseover="hoveredRegion = 'ภาคเหนือ'" 
        @mouseleave="hoveredRegion = null"
        class="region-group"
      >
        <path
          d="M 400 100 L 500 150 L 480 250 L 400 280 L 320 260 L 300 150 Z"
          :fill="getRegionColor('ภาคเหนือ')"
          :class="{ 'region-hover': hoveredRegion === 'ภาคเหนือ' }"
          stroke="white"
          stroke-width="2"
        />
        <text
          x="400"
          y="180"
          text-anchor="middle"
          class="region-label"
          :class="{ 'label-hover': hoveredRegion === 'ภาคเหนือ' }"
        >
          ภาคเหนือ
        </text>
        <text
          x="400"
          y="210"
          text-anchor="middle"
          class="region-value"
          :class="{ 'label-hover': hoveredRegion === 'ภาคเหนือ' }"
        >
          {{ formatData('ภาคเหนือ') }}
        </text>
      </g>

      <!-- Northeastern Region -->
      <g 
        @mouseover="hoveredRegion = 'ภาคตะวันออกเฉียงเหนือ'" 
        @mouseleave="hoveredRegion = null"
        class="region-group"
      >
        <path
          d="M 520 200 L 650 180 L 680 350 L 600 380 L 520 300 Z"
          :fill="getRegionColor('ภาคตะวันออกเฉียงเหนือ')"
          :class="{ 'region-hover': hoveredRegion === 'ภาคตะวันออกเฉียงเหนือ' }"
          stroke="white"
          stroke-width="2"
        />
        <text
          x="600"
          y="280"
          text-anchor="middle"
          class="region-label"
          :class="{ 'label-hover': hoveredRegion === 'ภาคตะวันออกเฉียงเหนือ' }"
        >
          อีสาน
        </text>
        <text
          x="600"
          y="310"
          text-anchor="middle"
          class="region-value"
          :class="{ 'label-hover': hoveredRegion === 'ภาคตะวันออกเฉียงเหนือ' }"
        >
          {{ formatData('ภาคตะวันออกเฉียงเหนือ') }}
        </text>
      </g>

      <!-- Central Region -->
      <g 
        @mouseover="hoveredRegion = 'ภาคกลาง'" 
        @mouseleave="hoveredRegion = null"
        class="region-group"
      >
        <path
          d="M 380 300 L 520 280 L 550 450 L 450 500 L 350 420 Z"
          :fill="getRegionColor('ภาคกลาง')"
          :class="{ 'region-hover': hoveredRegion === 'ภาคกลาง' }"
          stroke="white"
          stroke-width="2"
        />
        <text
          x="450"
          y="400"
          text-anchor="middle"
          class="region-label"
          :class="{ 'label-hover': hoveredRegion === 'ภาคกลาง' }"
        >
          ภาคกลาง
        </text>
        <text
          x="450"
          y="430"
          text-anchor="middle"
          class="region-value"
          :class="{ 'label-hover': hoveredRegion === 'ภาคกลาง' }"
        >
          {{ formatData('ภาคกลาง') }}
        </text>
      </g>

      <!-- Eastern Region -->
      <g 
        @mouseover="hoveredRegion = 'ภาคตะวันออก'" 
        @mouseleave="hoveredRegion = null"
        class="region-group"
      >
        <path
          d="M 550 350 L 680 340 L 750 500 L 650 550 L 550 450 Z"
          :fill="getRegionColor('ภาคตะวันออก')"
          :class="{ 'region-hover': hoveredRegion === 'ภาคตะวันออก' }"
          stroke="white"
          stroke-width="2"
        />
        <text
          x="650"
          y="420"
          text-anchor="middle"
          class="region-label"
          :class="{ 'label-hover': hoveredRegion === 'ภาคตะวันออก' }"
        >
          ตะวันออก
        </text>
        <text
          x="650"
          y="450"
          text-anchor="middle"
          class="region-value"
          :class="{ 'label-hover': hoveredRegion === 'ภาคตะวันออก' }"
        >
          {{ formatData('ภาคตะวันออก') }}
        </text>
      </g>

      <!-- Western Region -->
      <g 
        @mouseover="hoveredRegion = 'ภาคตะวันตก'" 
        @mouseleave="hoveredRegion = null"
        class="region-group"
      >
        <path
          d="M 250 350 L 380 320 L 420 500 L 350 550 L 220 480 Z"
          :fill="getRegionColor('ภาคตะวันตก')"
          :class="{ 'region-hover': hoveredRegion === 'ภาคตะวันตก' }"
          stroke="white"
          stroke-width="2"
        />
        <text
          x="320"
          y="430"
          text-anchor="middle"
          class="region-label"
          :class="{ 'label-hover': hoveredRegion === 'ภาคตะวันตก' }"
        >
          ตะวันตก
        </text>
        <text
          x="320"
          y="460"
          text-anchor="middle"
          class="region-value"
          :class="{ 'label-hover': hoveredRegion === 'ภาคตะวันตก' }"
        >
          {{ formatData('ภาคตะวันตก') }}
        </text>
      </g>

      <!-- Southern Region -->
      <g 
        @mouseover="hoveredRegion = 'ภาคใต้'" 
        @mouseleave="hoveredRegion = null"
        class="region-group"
      >
        <path
          d="M 350 520 L 450 500 L 500 700 L 380 800 L 250 700 Z"
          :fill="getRegionColor('ภาคใต้')"
          :class="{ 'region-hover': hoveredRegion === 'ภาคใต้' }"
          stroke="white"
          stroke-width="2"
        />
        <text
          x="400"
          y="620"
          text-anchor="middle"
          class="region-label"
          :class="{ 'label-hover': hoveredRegion === 'ภาคใต้' }"
        >
          ภาคใต้
        </text>
        <text
          x="400"
          y="650"
          text-anchor="middle"
          class="region-value"
          :class="{ 'label-hover': hoveredRegion === 'ภาคใต้' }"
        >
          {{ formatData('ภาคใต้') }}
        </text>
      </g>

      <!-- Bangkok -->
      <g 
        @mouseover="hoveredRegion = 'กทม.'" 
        @mouseleave="hoveredRegion = null"
        class="region-group"
      >
        <circle
          cx="450"
          cy="380"
          r="30"
          :fill="getRegionColor('กทม.')"
          :class="{ 'region-hover': hoveredRegion === 'กทม.' }"
          stroke="white"
          stroke-width="2"
        />
        <text
          x="450"
          y="385"
          text-anchor="middle"
          class="region-label-small"
          :class="{ 'label-hover': hoveredRegion === 'กทม.' }"
        >
          กทม.
        </text>
      </g>
    </svg>

    <!-- Legend -->
    <div class="legend">
      <div class="legend-title">
        <v-icon small>mdi-information</v-icon>
        ตำนานแผนที่
      </div>
      <div class="legend-content">
        <div
          v-for="(count, region) in regionStats"
          :key="region"
          class="legend-item"
          :class="{ 'legend-active': hoveredRegion === region }"
        >
          <div
            class="legend-color"
            :style="{ backgroundColor: getRegionColor(region) }"
          ></div>
          <span class="legend-text">{{ region }}: {{ count | formatNumber }}</span>
        </div>
      </div>
    </div>

    <!-- Tooltip -->
    <v-card
      v-if="hoveredRegion"
      class="region-tooltip"
      elevation="8"
    >
      <v-card-text>
        <div class="tooltip-region">{{ hoveredRegion }}</div>
        <div class="tooltip-value">
          จำนวนนักเรียน: <strong>{{ formatData(hoveredRegion) }}</strong>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ThailandMap',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      hoveredRegion: null,
      regionStats: {
        'ภาคเหนือ': 0,
        'ภาคตะวันออกเฉียงเหนือ': 0,
        'ภาคกลาง': 0,
        'ภาคตะวันออก': 0,
        'ภาคตะวันตก': 0,
        'ภาคใต้': 0,
        'กทม.': 0
      },
      regionColors: {
        'ภาคเหนือ': '#FF6B6B',
        'ภาคตะวันออกเฉียงเหนือ': '#4ECDC4',
        'ภาคกลาง': '#45B7D1',
        'ภาคตะวันออก': '#FFA07A',
        'ภาคตะวันตก': '#98D8C8',
        'ภาคใต้': '#F7DC6F',
        'กทม.': '#BB8FCE'
      }
    };
  },
  filters: {
    formatNumber(value) {
      if (!value) return '0';
      return Number(value).toLocaleString('th-TH');
    }
  },
  watch: {
    data: {
      handler(newData) {
        this.updateRegionStats();
      },
      deep: true
    }
  },
  mounted() {
    this.updateRegionStats();
  },
  methods: {
    updateRegionStats() {
      Object.keys(this.regionStats).forEach(region => {
        this.regionStats[region] = (this.data[region]?.count || 0);
      });
    },
    formatData(region) {
      const count = this.regionStats[region] || 0;
      return count.toLocaleString('th-TH');
    },
    getRegionColor(region) {
      const count = this.regionStats[region] || 0;
      
      // ปรับเฉดสีตามปริมาณนักเรียน
      if (count === 0) return '#E0E0E0';
      
      const maxCount = Math.max(...Object.values(this.regionStats));
      const ratio = count / maxCount;
      
      // ปรับความเข้มของสี
      const baseColor = this.regionColors[region];
      return this.adjustColorIntensity(baseColor, ratio);
    },
    adjustColorIntensity(hexColor, ratio) {
      // ส่วนใหญ่ใช้สีฐาน ปรับให้เข้มขึ้นตามสัดส่วน
      return hexColor;
    }
  }
};
</script>

<style lang="scss" scoped>
.thailand-map-container {
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;

  .thailand-map {
    width: 100%;
    max-width: 600px;
    height: auto;
  }

  .region-group {
    cursor: pointer;
    transition: all 0.3s ease;

    path,
    circle {
      transition: all 0.3s ease;
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));

      &.region-hover {
        filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
      }
    }

    &:hover {
      path,
      circle {
        filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.25));
        opacity: 0.9;
      }

      .region-label,
      .region-label-small {
        font-weight: bold;
        font-size: 18px;
      }
    }

    .region-label,
    .region-label-small,
    .region-value {
      font-family: 'Roboto', sans-serif;
      pointer-events: none;
      text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);
      transition: all 0.3s ease;

      &.label-hover {
        font-weight: bold;
      }
    }

    .region-label {
      font-size: 14px;
      font-weight: 600;
      fill: white;
    }

    .region-label-small {
      font-size: 12px;
      font-weight: 700;
      fill: white;
    }

    .region-value {
      font-size: 12px;
      fill: white;
      font-weight: 500;
    }
  }

  .legend {
    margin-top: 24px;
    padding: 16px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .legend-title {
      font-weight: 600;
      font-size: 14px;
      margin-bottom: 12px;
      color: #333;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .legend-content {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 12px;
    }

    .legend-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      border-radius: 4px;
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover,
      &.legend-active {
        background: #F5F5F5;
        transform: translateX(4px);
      }

      .legend-color {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        border: 2px solid white;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      .legend-text {
        font-size: 12px;
        color: #555;
        font-weight: 500;
      }
    }
  }

  .region-tooltip {
    position: fixed;
    bottom: 20px;
    right: 20px;
    border-radius: 8px !important;
    z-index: 10;

    .tooltip-region {
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 8px;
      color: #1976D2;
    }

    .tooltip-value {
      font-size: 13px;
      color: #555;
    }
  }
}

@media (max-width: 768px) {
  .thailand-map-container {
    .legend {
      .legend-content {
        grid-template-columns: 1fr;
      }
    }

    .region-tooltip {
      bottom: 10px !important;
      right: 10px !important;
    }
  }
}
</style>